import { render, staticRenderFns } from "./ModalUpsertComorbidade.vue?vue&type=template&id=d55ecb84&scoped=true"
import script from "./ModalUpsertComorbidade.vue?vue&type=script&lang=ts"
export * from "./ModalUpsertComorbidade.vue?vue&type=script&lang=ts"
import style0 from "./ModalUpsertComorbidade.vue?vue&type=style&index=0&id=d55ecb84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55ecb84",
  null
  
)

export default component.exports